import Text from '../../../../components/Text'
import anayaImgUrls, {
  journeySteps,
} from '../../../../constants/anaya-constants'

const Journey = () => {
  return (
    <section>
      <div className="px-5 pt-6 space-y-7">
        <Text
          tag="p"
          variant="headline"
          size="large"
          className="text-[#213053]"
        >
          Start your care journey in 3 easy steps
        </Text>

        {/* Steps Section */}
        <div className="flex flex-col gap-8">
          {journeySteps.map((step, index) => (
            <div key={step.title} className="flex items-center gap-4">
              <div className="w-14 h-14 min-w-14 min-h-14 bg-secondary rounded-[20px] flex items-center justify-center text-[32px] text-white shadow-[0px_5px_0px_0px_#A17805;]">
                {index + 1}
              </div>
              <Text
                tag="p"
                variant="title"
                size="small"
                className="text-[#475467] pr-4 !leading-[1.3]"
              >
                {step.title}
              </Text>
            </div>
          ))}
        </div>

        {/* Image Section */}
        <div className="">
          <Text
            tag="p"
            variant="headline"
            size="large"
            className="text-[#213053] px-3 pt-10 !text-center max-w-[80%] mx-auto"
          >
            Together, We Fight Cancer
          </Text>
          <img src={anayaImgUrls.caregiverWithPatient} alt="journey" />
        </div>
      </div>
    </section>
  )
}

export default Journey
